module.exports = __webpack_public_path__ + "img/land-owners-overview-8a5447f.jpg";